import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

//import�'vuetify/src/stylus/app.styl'

Vue.use(Vuetify)

export default new Vuetify() 




//import Vue from 'vue'
//import Vuetify from 'vuetify/lib'
////import 'vuetify/src/stylus/app.styl'
//import colors from 'vuetify/lib/util/colors'

//Vue.use(Vuetify)

//export default new Vuetify({
//    icons: {
//        iconfont: 'md',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
//    },
//    theme: {
//        dark: false,
//    },
//    themes: {
//        light: {
//            primary: "#4682b4",
//            secondary: "#b0bec5",
//            accent: "#8c9eff",
//            error: "#b71c1c",
//        },
//    },
//})


//Vue.use(Vuetify, {
//    theme: {
        
//        primary: '#1976D2',
//        secondary: '#424242',
//        accent: '#82B1FF',
//        error: '#FF5252',
//        info: '#2196F3',
//        success: '#4CAF50',
//        warning: '#FFC107',
//        background: colors.grey.lighten3
//    },
//    options: {
//        customProperties: true
//    },
//    iconfont: 'mdi'
//})
